(function () {
    'use strict';

    angular
        .module('elogbooks')
        .controller('EmailVerificationController', EmailVerificationController);

    EmailVerificationController.$inject = [
        'rootResponse',
        '$http',
        'messenger',
        '$state',
        '$interval',
        'userManager',
        '$window',
        '$translate',
        'API_URL',
        'modulesService'
    ];

    function EmailVerificationController(
        rootResponse,
        $http,
        messenger,
        $state,
        $interval,
        userManager,
        $window,
        $translate,
        API_URL,
        modulesService
    ) {
        var vm = this;
        const lastEmailVerificationSentAt = $window.localStorage.getItem('lastEmailVerificationSentAt');
        vm.helpdeskPhoneNumber = rootResponse ? rootResponse.helpdeskPhoneNumber : null;
        vm.themePrefix = rootResponse?.theme ?? 'cafm';
        vm.email = $window.localStorage.getItem('userEmail');
        vm.verificationCode = '';
        vm.counter = 30;
        vm.resent = false;
        vm.verificationFailMsg = null;
        vm.submitDisabled = false;
        vm.wrongCode = false;
        vm.locked = false;
        vm.newCodeSent = false;
        vm.topText = $translate.instant('PLEASE_VERIFY_TEXT', {email: vm.email});
        vm.pleaseContactText = $translate.instant('PLEASE_CONTACT_HELPDESK', {helpdeskNumber: vm.helpdeskPhoneNumber});

        var interval;

        vm.submitCode = submitCode;
        vm.reSendCode = reSendCode;
        vm.cancel = cancel;
        if (lastEmailVerificationSentAt ) {
            const timeDiff = Math.floor((Date.now() - new Date(lastEmailVerificationSentAt).getTime()) / 1000);
            if (timeDiff >= 0 && timeDiff < 30) {
                vm.resent = true;
                vm.counter = 30 - timeDiff;
                interval = $interval(startCountdown,1000);
            }
        }

        function startCountdown() {
            vm.counter--;
            if (vm.counter == 0) {
                vm.resent = false;
                $interval.cancel(interval);
                vm.counter = 30;
            }
        }

        function reSendCode() {
            vm.resent = true;
            vm.counter = 30;
            interval = $interval(startCountdown,1000);
            vm.newCodeSent = true;
            $http.post(API_URL + rootResponse.getLink('resend-email-verification')).then((response) => {
                if (response) {
                    $window.localStorage.setItem('lastEmailVerificationSentAt', response.data.last_email_verification_sent_at);
                    messenger.success(response.data.message);
                    vm.verificationCode = '';
                }
            }, (response) => {
                if (response) {
                    messenger.error(response.data.message);
                }
            });
        }

        function submitCode() {
            if (vm.locked) {
                return;
            }

            vm.submitDisabled = true;
            vm.wrongCode = false;
            $http.post(API_URL + rootResponse.getLink('verify-email'), {code: vm.verificationCode}).then((response) => {
                if (response) {
                    if (response.data.email_verified) {
                        $window.localStorage.setItem('token', response.data.token);
                        $window.localStorage.setItem('userResource', response.data.userHref);
                        $window.localStorage.setItem('tokenLink', response.data.tokenHref);
                        $window.localStorage.removeItem('recaptchaRequired');
                        $window.localStorage.removeItem('userEmail');
                        // get user resource to enable checking preferences
                        userManager.getUser().then(() => {
                            if ((userManager.hasPermission("site_permission_helpdesk")) && (!userManager.hasPermission("user_permission_manage_users"))) {
                                var targetState = modulesService.isEnabled('quotes') ? 'dashboard.helpdesk.dashboard.quotes.chase' : 'dashboard.helpdesk.dashboard.reactive-jobs.chase';
                                $state.go(targetState).then(() => {
                                    messenger.success(response.data.message);
                                });
                            } else {
                                $state.go('dashboard.user.dashboard').then(() => {
                                    messenger.success(response.data.message);
                                });
                            }
                        });
                    }
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            }, (response) => {
                if (response.data.message === "CODE_DOES_NOT_MATCH") {
                    vm.submitDisabled = false;
                    vm.wrongCode = true;
                    vm.verificationCode = '';
                    vm.topText = $translate.instant('VERIFICATION_CODE_DOES_NOT_MATCH', {
                        attempts: response.data.attempts > 1 ? response.data.attempts + ' attempts' :  response.data.attempts + ' attempt'
                    });
                } else if (response.data.message === "CODE_EXPIRED_REQUEST_NEW_CODE") {
                    vm.submitDisabled = false;
                    vm.verificationCode = '';
                    messenger.error(response.data.message);
                } else if (response.data.message === 'TOO_MANY_ATTEMPTS_ACCOUNT_LOCKED') {
                    vm.submitDisabled = false;
                    vm.wrongCode = true;
                    vm.locked = true;
                    vm.verificationFailMsg = $translate.instant('VERIFICATION_CODE_FAILED_3_TIMES');
                    vm.pleaseContactText = $translate.instant('PLEASE_CONTACT_HELPDESK', {helpdeskNumber: vm.helpdeskPhoneNumber});
                    $window.localStorage.removeItem('userEmail');
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function cancel() {
            userManager.logout();
            $state.go('login.step1');
        }
    }
})();
